// extracted by mini-css-extract-plugin
export default {"link":"styles-module--link--42015"};